var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 22.5C20.1421 22.5 23.5 19.1421 23.5 15C23.5 10.8579 20.1421 7.5 16 7.5C11.8579 7.5 8.5 10.8579 8.5 15C8.5 19.1421 11.8579 22.5 16 22.5Z",
    stroke: "black",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 3V4",
    stroke: "black",
    strokeWidth: 1.7,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 6.5L8.2 7.2",
    stroke: "black",
    strokeWidth: 1.7,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 15H5",
    stroke: "black",
    strokeWidth: 1.7,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 23.5L8.2 22.8",
    stroke: "black",
    strokeWidth: 1.7,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 27V26",
    stroke: "black",
    strokeWidth: 1.7,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 23.5L23.8 22.8",
    stroke: "black",
    strokeWidth: 1.7,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 15H27",
    stroke: "black",
    strokeWidth: 1.7,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 6.5L23.8 7.2",
    stroke: "black",
    strokeWidth: 1.7,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_24"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0.963867)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.901f665e097a19058df87d2bc656e75c.svg";
export { ForwardRef as ReactComponent };